import { Component, Output, EventEmitter, OnInit } from '@angular/core';
import { GlobalDataService} from '../../services/global-data.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

@Output() toggleSidebar = new EventEmitter(); 

button_caption: string="Выход";	
user_name: string="";
currency:any;

constructor(private router: Router, private global: GlobalDataService){

	this.user_name = this.global.user['contact'].full_name;
	this.currency= this.global.currencyRate;

}
 ngOnInit() {
	 this.currency = {currency : { short_name : ""}, value: ""};
    
}
 clickedToggle():void{
 	this.toggleSidebar.emit();
	}

 reset():void{
 	localStorage.removeItem('token');
 	this.router.navigate(['/dashboard/user-crud']);
 }	

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/header/header.component.ts